import { render, staticRenderFns } from "./TabRespo.vue?vue&type=template&id=59dd0e5d&scoped=true"
import script from "./TabRespo.vue?vue&type=script&lang=ts"
export * from "./TabRespo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd0e5d",
  null
  
)

export default component.exports